import {AfterViewInit, ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {PackageService} from '../../../services/package-service/package.service';
import {PackageResponse} from '../../../models/manager/dto/response/PackageResponse';
import {MenuController, ModalController, NavController, Platform} from '@ionic/angular';
import {ThemeSwitcherService} from '../../../services/theme-switch/theme-switcher.service';
import {Storage} from '@ionic/storage';
import {AppPermission} from '../../../models/comons/enums/AppPermission';
import {AlertService} from '../../../services/alert/alert.service';
import {AuthService} from '../../../services/auth/auth.service';
import {Router} from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'app-select-package',
    templateUrl: './select-package.page.html',
    styleUrls: ['./select-package.page.scss'],
})
export class SelectPackagePage implements OnInit, AfterViewInit {

    packages: PackageResponse[];
    selected: PackageResponse = null;
    appPermission: any = JSON.parse(JSON.stringify(AppPermission));
    request: boolean = false;
    oldThemeName: string = null;
    beforeRemovePackage: any;

    constructor(public packageService: PackageService,
                public theme: ThemeSwitcherService,
                public auth: AuthService,
                private storage: Storage,
                public modal: ModalController,
                private ngZone: NgZone,
                private alertService: AlertService,
                private router: Router,
                private menuController: MenuController,
                private cd: ChangeDetectorRef) {
        alertService.okButtonCallBack = this.okButtonCallBack.bind(this);
        alertService.cancelButtonCallBack = this.cancelButtonCallBack.bind(this);
    }

    okButtonCallBack = () => {
        console.log('press ok button');
    };
    cancelButtonCallBack = () => {
        console.log('press cancel button');
    };


    ngOnInit() {
        this.menuController.close('system-menu').then();

    }

    selectedPackage(item: PackageResponse) {
        this.selected = item;
        this.cd.detectChanges();
    }

    resetCurrentPackage(event) {
        this.beforeRemovePackage = {...this.auth.currentPackageInfo};
        this.auth.currentPackageInfo = null;
        this.auth.currentPackageSubject.next(this.auth.currentPackageInfo);
        this.selected = null;
        // this.theme.getStoredThemeName().then(value => {
        //     this.oldThemeName = value;
        // });
    }


    closeModal() {
        // if (!(_.isEqual(this.auth.currentPackageInfo, this.beforeRemovePackage)) && this.beforeRemovePackage) {
        //     if (this.oldThemeName === 'package_dark_template') {
        //         this.theme.setTheme(ThemeSwitcherService.package_dark_template, 'package_dark_template');
        //     } else {
        //         this.theme.setTheme(this.theme.getBaseColorTheme(this.beforeRemovePackage.theme), this.beforeRemovePackage.theme);
        //     }
        // }

        if (!this.auth.currentPackageInfo) {
            this.auth.currentPackageInfo = {...this.beforeRemovePackage};
            this.auth.currentPackageSubject.next(this.auth.currentPackageInfo);
        }
        this.modal.dismiss().then();
    }

    // hasPermission(permission: string): boolean {
    //     let appPermission: AppPermission;
    //     switch (permission) {
    //         case 'StaticQuiz':
    //             appPermission = AppPermission.StaticQuiz;
    //             break;
    //         case  'TopicQuiz':
    //             appPermission = AppPermission.TopicQuiz;
    //             break;
    //         case 'CustomQuiz':
    //             appPermission = AppPermission.CustomQuiz;
    //             break;
    //     }
    //     console.log(`package ${permission} permission: ${this.auth.currentPackageInfo.permissions.includes(appPermission)}`);
    //     return this.auth.currentPackageInfo.permissions.includes(appPermission);
    // }

    selectPackage() {
        if (this.selected) {
            this.packageService.getUserPackageById(this.selected.id).subscribe(result => {
                if (result.status && result.data) {
                    this.ngZone.run(() => {
                        this.storage.ready().then(() => {
                            this.storage.remove('current-package').then((success) => {
                                this.storage.set('current-package', JSON.stringify(result.data))
                                    .then(() => {
                                        this.auth.currentPackageInfo = result.data;
                                        this.auth.currentPackageSubject.next(this.auth.currentPackageInfo);
                                        // this.theme.setTheme(
                                        //     this.theme.getBaseColorTheme(this.selected.theme)
                                        //     , this.selected.theme);
                                        this.modal.dismiss().then();
                                        // setTimeout(() => {
                                        //     window.location.reload();
                                        // }, 400);
                                    });
                            }, reason => console.log(reason));
                        });
                    });
                } else {
                    this.alertService.alert('این آزمون برای شما یافت نشد', 'خطا').then();
                }
            });
        } else {
            this.alertService.alert('بسته مورد نظر را انتخاب کنید', 'انتخاب بسته').then();
        }
    }

    ngAfterViewInit(): void {

    }

    ionViewDidEnter() {
        this.request = true;

        this.auth.isAuthentication().then(value => {
            if (value) {
                this.packageService.getUserAllPackage(0, 1000).subscribe(res => {
                    if (res.status) {
                        this.packages = res.data;
                    }
                    this.request = false;
                    this.cd.detectChanges();
                }, error => {
                    this.request = false;
                    this.cd.detectChanges();
                    console.log(error);
                });
            }
        });
        this.cd.detectChanges();
    }

    async buyPackage(event) {
        this.modal.dismiss().then(() => {
            this.router.navigate(['/package/activate-package']);
            this.menuController.close('system-menu');
        });
    }

}
